import React, { Component } from 'react';
import PageTitle from '~/components/PageTitle';

import ReportList from './ReportList';
import RecordList from './RecordList';
import RelatedList from './RelatedList';
import MeetList from './MeetList';

class Page_IAMeet extends Component {
  render () {
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='相關會議與函文' />
        <ReportList />
        <RecordList />
        <RelatedList />
        <MeetList />
      </div>
    );
  }
}

export default Page_IAMeet;
